const React = require('react');
const { Component } = require('react');
const { LoginForm } = require('../../components/loginForm/loginForm.js');
const { LoadingSection } = require('commonsComponents/loadingSection');


class LoginViewContactCenter extends Component {
    render() {
        const ramdomValue = Math.random().toString();
        return (
            <div>
                <LoadingSection />
                <LoginForm r={ramdomValue} {...this.props} />
            </div>
        );
    }
}
module.exports = LoginViewContactCenter;
